import { useUserStore } from '@backmarket/nuxt-layer-oauth/useUserStore'
import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { usePhonelineSetup } from './usePhonelineSetup'

type FreenetPhonelineSetup =
  ApiSpecs['/mobile-plan/api/v1/customer-account/freenet/phone-line-setup']['GET']['response']

export function useFreenetPhonelineSetup() {
  const { user } = useUserStore()
  const $httpFetch = useHttpFetch()

  return usePhonelineSetup<FreenetPhonelineSetup>(
    `phoneline-setup-FREENET-${user.value?.bmUserId}`,
    () =>
      $httpFetch(
        '/mobile-plan/api/v1/customer-account/freenet/phone-line-setup',
      ),
  )
}
